var React = require('react');

function Beatport (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.54,10.86A4.92,4.92,0,0,0,8.92,7.14a5,5,0,0,0-3.25,1l0,0s0,0,0,0A4.94,4.94,0,0,0,7,4.74C7,3.18,7,1.62,7,.06V0H4.55V.12c0,1.53,0,3.07,0,4.6a2.54,2.54,0,0,1-.79,1.87L.19,10.12,0,10.29l1.77,1.76L4.91,8.91h0v0a4.87,4.87,0,0,0-1.08,2.7,4.94,4.94,0,0,0,.59,2.82,4.87,4.87,0,0,0,5.32,2.43A4.92,4.92,0,0,0,13.54,10.86ZM8.73,14.73a2.67,2.67,0,1,1,2.71-2.67A2.68,2.68,0,0,1,8.73,14.73Z"}));
}

Beatport.defaultProps = {"width":"14","height":"17","viewBox":"0 0 14 17"};

module.exports = Beatport;

Beatport.default = Beatport;
